function AdditionalSection() {

    return(   <section className="doc-sec sec-padding">
    <div className="container">
        <div className="sec-title">
            <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-ticket fa-stack-1x"></i></span></span>
            <h3 className="wow fadeInRight" data-wow-duration="500ms">Register Now <small>/ Avail great discounts by registering early.</small></h3>
        </div> {/* <!--sec-title end--> */}
        <div className="doc-sec-details">
            <p>Avail early bird discounts by registering now! Reach out for exciting offers on group discounts. Gain by bringing in more of your friends and colleagues to attend! The more, the merrier!.</p>
            {/*<a href="#" title="" className="btn-default">Make a donation now</a>-*/}
        </div> {/* <!-- about-sec-details end--> */}
    </div>
</section>

)};
export {AdditionalSection};
